import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';
import Lenis from 'lenis';

import { fetch_one } from "../../../../lib/v31lib";
import { loginAtom } from '../../../../lib/auth';

// import Lenis from "lenis";
// import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { gsap } from "gsap";

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import DownloadIcon from '@mui/icons-material/Download';
import ErrorIcon from '@mui/icons-material/Error';

import {
  Box,
  Divider,
  Grid,
  MenuItem,
} from '@mui/material';
// import {
//   WhiteSection
// } from '../../../components/v2/custom';
import {
  DarkGreenButton,
  GiftCode,
  IconButton,
  LightGreenButton,
  Select,
  ShareShower,
  Stepper,
  TextButton,
  TextInput,
  TransparentButton,
  Typography
} from '../../../../components/v2/styled';
import { OtpCode } from '../../../../components/v2/styled/OtpCode';
import { Vennr } from '../../../../components/v2/styled/Vennr';
import { Birthdate } from '../../../../components/v2/styled/Birthdate';
import { WhiteSection } from '../../../../components/v2/custom';

import { EmissionKey } from '../../../../models/EmissionKey';
import { Guardian } from '../../../../models/Guardian';
import { User } from '../../../../models/User';
import { ErrorBox } from '../../../../components/v2/styled/ErrorBox';
import { ZichtAccount } from '../../../../components/v2/styled/ZichtAccount';
import { DropzoneArea } from 'mui-file-dropzone';

var he = require('he');
const { DateTime } = require("luxon");

type Props = {
  setStep: (n:number) => void;
  lenis: Lenis;
}

export const EmissionGiftRedeemGift: FunctionComponent<Props> = ({setStep, lenis}) => {
  const [login, setLogin] = useAtom(loginAtom);
  const theme = useTheme();
  // const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [vennr, setVennr] = useState<string>('');
  const [birthdate, setBirthdate] = useState<string>('');
  const [otp, setOtp] = useState<string>('');
  const [showOtp, setShowOtp] = useState<boolean>(false);
  const [user, setUser] = useState<User>({
    id: undefined,
    auth_token: '',
    email: '',
    gender: 'M'
  });
  const [guardian, setGuardian] = useState<Guardian>({
    id: undefined,
    email: ''
  });
  const [theKey, setTheKey] = useState<EmissionKey>({});
  const [showSuccess, setShowSuccess] = useState<boolean>(false);
  const [keyAsn, setKeyAsn] = useState<string>('');
  const [firstName, setFirstName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [subStep, setSubStep] = useState<number>(0);
  const [showError, setShowError] = useState<boolean>(false);
  const [isNew, setIsNew] = useState<boolean>(true);
  const [error, setError] = useState<string>();
  const [hasGuardian, setHasGuardian] = useState<boolean>(false);
  const [isOkay, setIsOkay] = useState<boolean>(false);
  const [samesiesAddress, setSamesiesAddress] = useState<boolean>(true);
  const [samesiesContact, setSamesiesContact] = useState<boolean>(true);
  const [borderel, setBorderel] = useState<File>();
  const [blankUrl, setBlankUrl] = useState<string>();









  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
      step: number;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/${i18n.resolvedLanguage || 'nl'}/v3/pub/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      console.log(data);

      setShowOtp(false);
      setShowError(false);
      setError(undefined);

      if (variables.step === 0) { // verification
        if (!data.custom_result.error) {
          setSubStep(1);
          setTimeout(() => {
            // lenis.scrollTo("top");
            window.scrollTo(0, 0);
          }, 200);
        } else {
          setError(data.custom_result.message);
          setShowError(true);
        }
      }
      if (variables.step === 12) { // verification
        if (!!data.custom_result.mfa_status_0_verification) {
          setShowOtp(true);
        } else {
          if (!data.custom_result.message) {
            setUser({
              id: data.custom_result.id,
              first_name: data.custom_result.first_name,
              last_name: data.custom_result.last_name,
              vennoot_number: data.custom_result.vennoot_number,
              guardian: data.custom_result.guardian,
              max_shares_left: data.custom_result.max_shares_left,
              email: '',
              auth_token: ''
            });
            setSubStep(13);
          } else {
            setError(data.custom_result.message);
            setShowError(true);
          }
        }
      }
      if (variables.step === 20) {
        if (!!data.custom_result.active_key.borderel_blank) {
          window.open(data.custom_result.active_key.borderel_blank, "_BLANK");
        }
      }
      if (variables.step === 50) { // confirm
        setShowSuccess(true);
      }

      if (!!data.custom_result.user) {
        setUser({
          ...data.custom_result.user,
          birth_date: DateTime.fromISO(data.custom_result.user?.birth_date).toFormat("dd/LL/y")
        });
      }
      if (!!data.custom_result.active_key) {
        setTheKey({
          ...data.custom_result.active_key
        });
      }
    },
  });








  const subBtns = (backStep:number, nextStep:number, disabled:boolean, onClick?: ()=>void, confirm?: boolean) => {
    return <Grid item xs={12} sx={{textAlign: 'right', marginBottom: 8}}>
      <Box sx={{
        display: 'block',
        width: '100%',
        maxWidth: {
          xs: '100%',
          lg: '440px'
        },
        marginTop: 2,
        marginRight: 'auto',
        marginLeft: 'auto',
        textAlign: 'right'
      }}>
        <Box sx={{
          display: 'inline-block',
          width: {
            xs: '100%',
            lg: '49%'
          },
          textAlign: 'left',
          float: 'left'
        }}>
          <TextButton
            label={t("nw.emission.forgot.cta_back")}
            id="sub_btn"
            // disabled={backStep < 0}
            onClick={() => {
              if (backStep < 0) {
                setStep(0);
                setTimeout(() => {
                  // lenis.scrollTo("top");
                  window.scrollTo(0, 0);
                }, 200);
              } else {
                setSubStep(backStep);
                setTimeout(() => {
                  // lenis.scrollTo("top");
                  window.scrollTo(0, 0);
                }, 200);
              }
            }}
            sx={{
              marginBottom: 1,
              color: theme.palette.primary.dark,
              textDecoration: 'underline',
              "&:hover": {
                color: theme.palette.primary.light,
                backgroundColor: 'transparent'
              },
              paddingLeft: 0,
              paddingRight: 0
            }}
          />
        </Box>
        <Box sx={{
          display: 'inline-block',
          width: {
            xs: '100%',
            lg: '49%'
          },
          marginLeft: 'auto',
          textAlign: 'right'
        }}>
          <DarkGreenButton
            label={t(!!confirm ? "nw.gifts.cta_confirm" : "nw.register.hero.cta")}
            id="sub_btn"
            sx={{
              marginBottom: 1,
              borderColor: theme.palette.primary.dark,
              "&:hover": {
                borderColor: theme.palette.primary.dark,
                backgroundColor: theme.palette.primary.light,
                color: theme.palette.primary.dark,
              },
              "&.Mui-disabled": {
                color: 'grey',
              },
            }}
            disabled={disabled}
            loading={mutationCustomAction.isPending}
            onClick={() => {
              if (!!onClick) {
                onClick();
              } else {
                setSubStep(nextStep);
                setTimeout(() => {
                  // lenis.scrollTo("top");
                  window.scrollTo(0, 0);
                }, 200);
              }
            }}
          />
        </Box>
      </Box>
    </Grid>
  }
  const tableRow = (label: string, content: string|undefined, children: any, divider: boolean, copyable?: boolean, lessPadding?: boolean) => {
    return <>
      <Grid item xs={12} sm={4} sx={{
        paddingTop: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingBottom: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingLeft: {
          xs: 1,
          md: 2,
          lg: 3
        }
      }}>
        <Typography sx={{
          textTransform: 'uppercase',
          color: theme.palette.primary.light
        }}>{label}</Typography>
      </Grid>
      <Grid item xs={12} sm={8} sx={{
        paddingTop: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingBottom: !lessPadding ? {
          xs: 1,
          md: 2,
          lg: 3
        } : 0,
        paddingRight: {
          xs: 1,
          md: 2,
          lg: 3
        },
        position: 'relative'
      }}>
        {!!content && <Typography variant="body1" html fuck_p_tags>{content}</Typography>}
        {!!children && children}
      </Grid>

      {!!divider && <Grid item xs={12}>
        <Divider />
      </Grid>}
    </>;
  }

  useEffect(() => {
    if (!!user?.birth_date) setHasGuardian(DateTime.fromFormat(user?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}));
  }, [user?.birth_date]);

  return <>
    <WhiteSection isTransparent sx={{
      "& > div > div": {
        padding: 0
      },
      "& > div > div > div > div": {
        minHeight: 20,
        height:'auto'
      }
    }}>
      <Grid container spacing={1} sx={{
        width: {
          xs: '100%',
          lg: '900px'
        },
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: 4
      }}>
        <Grid item xs={12} sx={{textAlign: 'center', marginBottom: 8}}>
          <Stepper activeStep={subStep > 10 ? (subStep - 10) : subStep} steps={!!isNew ? 9 : 4} />
        </Grid>
        <Grid item xs={12} sx={{textAlign: 'center'}}>
          <Typography variant="h1" sx={{
            display: 'inline-block',
          }}>{t("nw.emission.redeem_gift.title")}</Typography>
        </Grid>

        {!!showError && <>
          <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              display: 'inline-block',
              color: theme.palette.warning.main
            }}>{t(error || '')}</Typography>
          </Grid>
          <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <TextButton
              id="back_btn"
              label={t("nw.emission.forgot.cta_back")}
              onClick={() => {
                setSubStep(0);
                setKeyAsn('');
                setShowError(false);
                setStep(0);
                setTimeout(() => {lenis.scrollTo(0);}, 200);
              }}
              sx={{
                marginLeft: 1,
                marginRight: 1,
                marginTop: 1
              }}
            />
          </Grid>
        </>}
        {!!showSuccess && <>
          <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              display: 'inline-block',
              color: theme.palette.primary.light
            }}>{t("nw.gifts.confirmed_awaiting_argenco")}</Typography>
          </Grid>
          <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <TextButton
              id="back_btn"
              label={t("nw.emission.forgot.cta_back")}
              onClick={() => {
                setSubStep(0);
                setKeyAsn('');
                setShowError(false);
                setStep(0);
                setTimeout(() => {lenis.scrollTo(0);}, 200);
              }}
              sx={{
                marginLeft: 1,
                marginRight: 1,
                marginTop: 1
              }}
            />
          </Grid>
        </>}
        {!showError && !showSuccess && <>
          {!theKey?.id && <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
            <Typography variant="subtitle1" html fuck_p_tags sx={{
              display: 'inline-block',
            }}>{t("nw.emission.redeem_gift.subsection")}</Typography>
          </Grid>}

          {subStep === 0 && <>
            <Grid item xs={12}>
              <Box sx={{
                display: 'block',
                width: '100%',
                maxWidth: {
                  xs: '100%',
                  lg: '440px'
                },
                marginTop: 4,
                marginRight: 'auto',
                marginLeft: 'auto'
              }}>
                <GiftCode
                  value={keyAsn || ''}
                  onChange={(v) => {
                    setKeyAsn(v.target.value);
                  }}
                  starred
                  caption={t("nw.emission.steps.redeem_gift.field.code")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Box>
            </Grid>
            {subBtns(-1, 1, (!keyAsn || (!!keyAsn && keyAsn.replace(/[^0-9]/g, '').length !== 12)), () => {
              mutationCustomAction.mutate({
                step: 0,
                formData: {
                  object: 'emission_key',
                  class_action: 'custom_api_validate_giftcode',
                  asn: keyAsn,
                  basic_info: 1
                }
              });
            })}
          </>}
          {subStep === 1 && <>
            <Grid item xs={12} sx={{
              marginBottom: 2.5,
              marginTop: 4
            }}>
              <Box
                sx={{
                  width: {
                    xs: '100%',
                    md: '100%',
                    lg: '670px'
                  },
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  backgroundColor: 'white'
                }}
              >
                <Grid container spacing={0}>
                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.gifter_name"), 
                    theKey.gifter?.first_name, 
                    undefined,
                    true
                  )}

                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.receiver_name"), 
                    theKey.gift_data?.first_name, 
                    undefined,
                    true
                  )}

                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.gift_expiry_date"), 
                    DateTime.fromISO(theKey.gift_expiry_date).toFormat("dd/LL/y"), 
                    undefined, 
                    true
                  )}

                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.amount"), 
                    undefined, 
                    <ShareShower sx={{fontWeight: {xs: 'bold', md: 'normal'}}} amount={theKey.proposed_amount} share={'B'} />, 
                    true
                  )}
                </Grid>
              </Box>
            </Grid>
            
            <Grid item xs={12}>
              <Box sx={{
                display: 'block',
                width: '100%',
                maxWidth: {
                  xs: '100%',
                  lg: '440px'
                },
                marginTop: 4,
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'center'
              }}>
                <DarkGreenButton
                  id="existing_member"
                  label={t("nw.emission.choice_me.new_member")}
                  onClick={() => {
                    setSubStep(12);
                    setIsNew(false);
                    window.scrollTo(0, 0);
                  }}
                  sx={{
                    marginLeft: 1,
                    marginRight: 1,
                    marginTop: 1
                  }}
                />
                <LightGreenButton
                  id="new_member"
                  label={t("nw.emission.choice_me.existing_member")}
                  onClick={() => {
                    setSubStep(2);
                    setIsNew(true);
                    window.scrollTo(0, 0);
                  }}
                  sx={{
                    marginLeft: 1,
                    marginRight: 1,
                    marginTop: 1
                  }}
                />
              </Box>
            </Grid>
          </>}






          {/* {if bestaand} */}
          {subStep === 12 && <>
            <Grid item xs={12} sx={{textAlign: 'center', paddingTop: 4}}>
              <Box sx={{
                display: 'inline-block',
                width: {
                  xs: '100%',
                  lg: '440px'
                },
                textAlign: 'left'
              }}>
                <Vennr
                  value={vennr || ''}
                  onChange={(v) => {
                    setVennr(v.target.value);
                  }}
                  starred
                  caption={t("nw.register.form.lidnummer")}
                  error={(!!vennr && vennr[0].toUpperCase() !== "B") ? t("nw.gifts.redeem.error.not_for_a") : undefined}
                  // placeholder={t("nw.contact.form.placeholder.first_name")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent'
                  }}
                />
                {(!!vennr && vennr[0].toUpperCase() !== "B") && <Box sx={{width: '100%', height: '1px'}}></Box>}
                <Birthdate
                  value={birthdate || ''}
                  hideError={(birthdate || '_').indexOf("_") > -1}
                  onChange={(v) => {
                    setBirthdate(v.target.value);
                  }}
                  starred
                  caption={t("nw.user_info.birth_date")}
                  // placeholder={t("nw.contact.form.placeholder.first_name")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
                {!!showOtp && <OtpCode
                  value={otp || ''}
                  onChange={(v) => {
                    setOtp(v.target.value);
                  }}
                  starred
                  caption={t("nw.public.otp_code")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />}
              </Box>
            </Grid>

            <Grid item xs={12} sx={{textAlign: 'right', marginBottom: 8}}>
              <Box sx={{
                display: 'block',
                width: '100%',
                maxWidth: {
                  xs: '100%',
                  lg: '440px'
                },
                marginTop: 2,
                marginRight: 'auto',
                marginLeft: 'auto',
                textAlign: 'right'
              }}>
                <Box sx={{
                  display: 'inline-block',
                  width: {
                    xs: '100%',
                    lg: '49%'
                  },
                  textAlign: 'left',
                  float: 'left'
                }}>
                  <TextButton
                    label={t("nw.emission.forgot.cta_back")}
                    id="sub_btn"
                    onClick={() => {
                      setSubStep(1);
                      setOtp('');
                      setTimeout(() => {lenis.scrollTo(0);}, 200);
                    }}
                    sx={{
                      marginBottom: 1,
                      color: theme.palette.primary.dark,
                      textDecoration: 'underline',
                      "&:hover": {
                        color: theme.palette.primary.light,
                        backgroundColor: 'transparent'
                      },
                      paddingLeft: 0,
                      paddingRight: 0
                    }}
                  />
                </Box>
                <Box sx={{
                  display: 'inline-block',
                  width: {
                    xs: '100%',
                    lg: '49%'
                  },
                  marginLeft: 'auto',
                  textAlign: 'right'
                }}>
                  <DarkGreenButton
                    label={t("nw.register.hero.cta")}
                    id="sub_btn"
                    sx={{
                      marginBottom: 1,
                      borderColor: theme.palette.primary.dark,
                      "&:hover": {
                        borderColor: theme.palette.primary.dark,
                        backgroundColor: theme.palette.primary.light,
                        color: theme.palette.primary.dark,
                      },
                      "&.Mui-disabled": {
                        color: 'grey',
                      },
                    }}
                    disabled={!vennr || (!!vennr && vennr[0].toUpperCase() !== "B") || !birthdate || !DateTime.fromFormat(birthdate, "dd/LL/y").isValid || (!!showOtp && !otp)}
                    onClick={() => {
                      mutationCustomAction.mutate({
                        formData: {
                          object: 'user',
                          class_action: 'custom_api_validate',
                          birthdate: birthdate,
                          vennr: vennr,
                          otp: otp.replace(" ", "").replace("_", ""),
                          basic_info: 1,
                          max_shares_left: 1
                        },
                        step: 12
                      });
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </>}
          {subStep === 13 && <>
            <Grid item xs={12} sx={{
              marginBottom: 2.5,
              marginTop: 4
            }}>
              <Box
                sx={{
                  width: {
                    xs: '100%',
                    md: '100%',
                    lg: '670px'
                  },
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  backgroundColor: 'white'
                }}
              >
                <Grid container spacing={0}>
                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.gifter_name"), 
                    theKey.gifter?.first_name, 
                    undefined,
                    true
                  )}

                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.receiver_name"), 
                    theKey.gift_data?.first_name, 
                    undefined,
                    true
                  )}

                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.gift_expiry_date"), 
                    DateTime.fromISO(theKey.gift_expiry_date).toFormat("dd/LL/y"), 
                    undefined, 
                    true
                  )}

                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.amount"), 
                    undefined, 
                    <ShareShower sx={{fontWeight: {xs: 'bold', md: 'normal'}}} amount={theKey.proposed_amount} share={'B'} />, 
                    true
                  )}

                  <Grid item xs={12} sx={{
                    paddingTop: {
                      xs: 1,
                      md: 2,
                      lg: 3
                    },
                    paddingBottom: {
                      xs: 1,
                      md: 2,
                      lg: 3
                    },
                    paddingLeft: {
                      xs: 1,
                      md: 2,
                      lg: 3
                    },
                    position: 'relative'
                  }}>
                    {((user.max_shares_left || 0) >= (theKey.proposed_amount || 0)) && <CheckCircleIcon sx={{color: theme.palette.primary.light, position: 'absolute', top: 24, left: 16}} />}
                    {((user.max_shares_left || 0) < (theKey.proposed_amount || 0)) && <ErrorIcon sx={{color: theme.palette.warning.main, position: 'absolute', top: 24, left: 16}} />}
                    {((user.max_shares_left || 0) >= (theKey.proposed_amount || 0)) && <Typography variant="body1" html fuck_p_tags sx={{paddingLeft: 4}}>{t("nw.gifts.existing.redeem_all")}</Typography>}
                    {((user.max_shares_left || 0) < (theKey.proposed_amount || 0)) && <Typography variant="body1" html fuck_p_tags sx={{paddingLeft: 4}}>{t("nw.gifts.existing.redeem_part")}</Typography>}
                  </Grid>

                  {((user.max_shares_left || 0) < (theKey.proposed_amount || 0)) && tableRow(
                    t("nw.emission.steps.stock.order_detail.max_shares_left"), 
                    undefined, 
                    <ShareShower sx={{fontWeight: {xs: 'bold', md: 'normal'}}} amount={user.max_shares_left} share={'B'} />, 
                    true
                  )}

                  {/* {((user.max_shares_left || 0) < (theKey.proposed_amount || 0)) && tableRow(
                    t("nw.emission.steps.stock.order_detail.assign_amount"), 
                    undefined, 
                    <ShareShower sx={{fontWeight: {xs: 'bold', md: 'normal'}}} amount={user.max_shares_left} share={'B'} />, 
                    true
                  )} */}

                  {((user.max_shares_left || 0) < (theKey.proposed_amount || 0)) && tableRow(
                    t("nw.emission.steps.stock.order_detail.repay_amount"), 
                    undefined, 
                    <ShareShower sx={{fontWeight: {xs: 'bold', md: 'normal'}}} amount={(theKey.proposed_amount || 0) - (user.max_shares_left || 0)} share={'B'} />, 
                    true
                  )}
                </Grid>
              </Box>
            </Grid>

            {subBtns(12, 13, false, () => {
              const formData = new FormData();
              formData.append('object', 'emission_key');
              formData.append('class_action', 'custom_api_redeem');
              formData.append('id', theKey.id?.toString() || '');
              formData.append('user_id', user.id?.toString() || '');

              mutationCustomAction.mutate({
                formData: formData,
                step: 50
              });
            }, true)}
          </>}







          {/* {if nieuw} */}
          {subStep === 2 && <>
            <Grid item xs={12} sx={{textAlign: 'center'}}>
              <Typography variant="h3" sx={{
                marginTop: 4,
                display: 'inline-block'
              }}>{t(!!hasGuardian ? "nw.emission.choice_me_new_itsme.title_personal_ven" : "nw.emission.choice_me_new_itsme.title_personal")}</Typography>
            </Grid>
            <Grid item xs={5}>
              <TextInput
                value={user?.first_name || ''}
                onChange={(v) => {
                  setUser({
                    ...(user || {
                      auth_token: '',
                      email: ''
                    }),
                    first_name: v.toString()
                  });
                }}
                starred
                caption={t("nw.user_info.first_name")}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent',
                }}
              />
            </Grid>
            <Grid item xs={7}>
              <TextInput
                value={user?.last_name || ''}
                onChange={(v) => {
                  setUser({
                    ...(user || {
                      auth_token: '',
                      email: ''
                    }),
                    last_name: v.toString()
                  });
                }}
                starred
                caption={t("nw.user_info.last_name")}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent',
                }}
              />
            </Grid>
            <Grid item xs={7}>
              <Birthdate
                value={user?.birth_date || ''}
                hideError={(user?.birth_date || "_").indexOf("_") > -1}
                onChange={(v) => {
                  setUser({
                    ...(user || {
                      auth_token: '',
                      email: ''
                    }),
                    birth_date: v.target.value
                  });
                }}
                starred
                caption={t("nw.user_info.birth_date")}
                // placeholder={t("nw.contact.form.placeholder.first_name")}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent',
                }}
              />
            </Grid>
            <Grid item xs={5}>
              <Select
                id="subjects"
                caption={t("nw.user_info.gender")}
                starred
                fullWidth
                value={user?.gender || "M"}
                setValue={(v) => {
                  setUser({
                    ...(user || {
                      auth_token: '',
                      email: ''
                    }),
                    gender: v.toString()
                  });
                }}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  height: '40px',
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  backgroundColor: 'transparent',
                  "&:hover fieldset": {
                    borderColor: 'transparent !important'
                  }
                }}
              >
                <MenuItem value="M">{he.decode((t("nw.user_info.genders.male")).replace(/<[^>]*>?/gm, ''))}</MenuItem>
                <MenuItem value="V">{he.decode((t("nw.user_info.genders.female")).replace(/<[^>]*>?/gm, ''))}</MenuItem>
              </Select>
            </Grid>
            {!!hasGuardian && <>
              <Grid item xs={12} sx={{textAlign: 'center'}}>
                <Typography variant="h3" sx={{
                  marginTop: 4,
                  display: 'inline-block'
                }}>{t("nw.emission.choice_me_new_itsme.title_personal_guardian")}</Typography>
              </Grid>
              <Grid item xs={5}>
                <TextInput
                  value={guardian?.first_name || ''}
                  onChange={(v) => {
                    setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      first_name: v.toString()
                    });
                  }}
                  starred
                  caption={t("nw.user_info.first_name")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Grid>
              <Grid item xs={7}>
                <TextInput
                  value={guardian?.last_name || ''}
                  onChange={(v) => {
                    setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      last_name: v.toString()
                    });
                  }}
                  starred
                  caption={t("nw.user_info.last_name")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Grid>
              <Grid item xs={7}>
                <Birthdate
                  value={guardian?.birth_date || ''}
                  hideError={(guardian?.birth_date || "_").indexOf("_") > -1}
                  onChange={(v) => {
                    setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      birth_date: v.target.value
                    });
                  }}
                  starred
                  caption={t("nw.user_info.birth_date")}
                  // placeholder={t("nw.contact.form.placeholder.first_name")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Grid>
              {!!guardian?.birth_date && DateTime.fromFormat(guardian?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}) && <Grid item xs={12}>
                <ErrorBox
                  type="error"
                  noTitle
                  text={t("nw.emission.choice_me_new_itsme.error_age")}
                />
              </Grid>}
            </>}
            {subBtns(1, 3, (!user?.first_name || !user?.last_name || !user?.gender || !user?.birth_date || !DateTime.fromFormat(user?.birth_date, "dd/LL/y").isValid || (!!user?.birth_date && DateTime.fromFormat(user?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}) && (!guardian?.first_name || !guardian?.last_name || !guardian.birth_date || !DateTime.fromFormat(guardian?.birth_date, "dd/LL/y").isValid || (!!guardian.birth_date && DateTime.fromFormat(guardian?.birth_date, "dd/LL/y") > DateTime.now().minus({year: 18}))))))}
          </>}
          {subStep === 3 && <>
            <Grid item xs={12} sx={{textAlign: 'center'}}>
              <Typography variant="h3" sx={{
                marginTop: 4,
                display: 'inline-block'
              }}>{t("nw.emission.choice_me_new_itsme.title_contact_extra")}</Typography>
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'center'}}>
              <Typography variant="subtitle1" sx={{
                display: 'inline-block',
                fontStyle: 'italic'
              }}>{t("nw.emission.choice_me_new_itsme.title_contact_extra_email")}</Typography>
            </Grid>
            <Grid item xs={12} md={!!hasGuardian ? 6 : 12} container spacing={2}>
              {!!hasGuardian && <Grid item xs={12} sx={{textAlign: 'center'}}>
                <Typography variant="subtitle1" sx={{
                  display: 'inline-block',
                }}>{t("nw.emission.choice_me_new_itsme.title_personal_ven")}</Typography>
              </Grid>}
              <Grid item xs={12}>
                <TextInput
                  value={user?.email || ''}
                  onChange={(v) => {
                    setUser({
                      ...(user || {
                        auth_token: '',
                        email: ''
                      }),
                      email: v
                    });
                    if (!!hasGuardian && samesiesContact) setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      email: v
                    });
                  }}
                  caption={t("nw.user_info.email")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  value={user?.repeat_email || ''}
                  onChange={(v) => {
                    setUser({
                      ...(user || {
                        auth_token: '',
                        email: ''
                      }),
                      repeat_email: v
                    });
                    if (!!hasGuardian && samesiesContact) setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      repeat_email: v
                    });
                  }}
                  starred
                  caption={t("nw.user_info.repeat_email")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: (!!user?.email && !!user?.repeat_email && user?.email !== user?.repeat_email) ? 'red' : theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextInput
                  value={user?.phone || ''}
                  onChange={(v) => {
                    setUser({
                      ...(user || {
                        auth_token: '',
                        email: ''
                      }),
                      phone: v.toString()
                    });
                    if (!!hasGuardian && samesiesContact) setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      phone: v.toString()
                    });
                  }}
                  starred
                  caption={t("nw.user_info.phone")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Grid>
            </Grid>
            {!!hasGuardian && <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
              <Grid item xs={12} sx={{textAlign: 'center'}}>
                <Typography variant="subtitle1" sx={{
                  display: 'inline-block',
                }}>{t("nw.emission.choice_me_new_itsme.title_personal_guardian")}</Typography>
              </Grid>
              {!!samesiesContact && <Grid item xs={12}>
                <TransparentButton
                  label={t("nw.emission.choice_minor.contact_details_diff")}
                  id='contact_details_diff'
                  onClick={() => {
                    setSamesiesContact(false);
                  }}
                  sx={{
                    marginTop: 3
                  }}
                />
              </Grid>}
              {!samesiesContact && <>
                <Grid item xs={12}>
                  <TextInput
                    value={guardian?.email || ''}
                    onChange={(v) => {
                      setGuardian({
                        ...(guardian || {
                          auth_token: '',
                          email: ''
                        }),
                        email: v
                      });
                    }}
                    starred
                    caption={t("nw.user_info.email")}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextInput
                    value={guardian?.repeat_email || ''}
                    onChange={(v) => {
                      setGuardian({
                        ...(guardian || {
                          auth_token: '',
                          email: ''
                        }),
                        repeat_email: v
                      });
                    }}
                    starred
                    caption={t("nw.user_info.repeat_email")}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextInput
                    value={guardian?.phone || ''}
                    onChange={(v) => {
                      setGuardian({
                        ...(guardian || {
                          auth_token: '',
                          email: ''
                        }),
                        phone: v.toString()
                      });
                    }}
                    starred
                    caption={t("nw.user_info.phone")}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />
                </Grid>
              </>}
            </Grid>}
            {subBtns(2, 4, (
              !user?.email || !user?.repeat_email || (!!user?.email && !!user?.repeat_email && user?.email !== user?.repeat_email) || !user?.phone || (
                !!hasGuardian && (!guardian?.email || !guardian?.repeat_email || (!!guardian?.email && !!guardian?.repeat_email && guardian?.email !== guardian?.repeat_email) || !guardian?.phone)
              )
            ))}
          </>}
          {subStep === 4 && <>
            <Grid item xs={12} sx={{textAlign: 'center'}}>
              <Typography variant="h3" sx={{
                marginTop: 4,
                display: 'inline-block'
              }}>{t("nw.emission.choice_me_new_itsme.title_address")}</Typography>
            </Grid>
            <Grid item xs={12} md={!!hasGuardian ? 6 : 12} container spacing={2} sx={{alignContent: 'baseline'}}>
              {!!hasGuardian && <Grid item xs={12} sx={{textAlign: 'center'}}>
                <Typography variant="subtitle1" sx={{
                  display: 'inline-block',
                }}>{t("nw.emission.choice_me_new_itsme.title_personal_ven")}</Typography>
              </Grid>}
              <Grid item xs={8}>
                <TextInput
                  value={user?.street || ''}
                  onChange={(v) => {
                    setUser({
                      ...(user || {
                        auth_token: '',
                        email: ''
                      }),
                      street: v
                    });
                    if (!!hasGuardian && samesiesAddress) setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      street: v
                    });
                  }}
                  starred
                  caption={t("nw.user_info.street")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextInput
                  value={user?.number || ''}
                  onChange={(v) => {
                    setUser({
                      ...(user || {
                        auth_token: '',
                        email: ''
                      }),
                      number: v
                    });
                    if (!!hasGuardian && samesiesAddress) setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      number: v
                    });
                  }}
                  starred
                  caption={t("nw.user_info.number")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Grid>
              <Grid item xs={4}>
                <TextInput
                  value={user?.zip || ''}
                  onChange={(v) => {
                    setUser({
                      ...(user || {
                        auth_token: '',
                        email: ''
                      }),
                      zip: v
                    });
                    if (!!hasGuardian && samesiesAddress) setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      zip: v
                    });
                  }}
                  starred
                  caption={t("nw.user_info.zip")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Grid>
              <Grid item xs={8}>
                <TextInput
                  value={user?.city || ''}
                  onChange={(v) => {
                    setUser({
                      ...(user || {
                        auth_token: '',
                        email: ''
                      }),
                      city: v
                    });
                    if (!!hasGuardian && samesiesAddress) setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      city: v
                    });
                  }}
                  starred
                  caption={t("nw.user_info.city")}
                  sx={{
                    borderRadius: "8px",
                    width: '100%',
                    border: "2px solid transparent",
                    borderColor: theme.palette.primary.dark,
                    paddingTop: 0.25,
                    paddingBottom: 0.25,
                    height: '40px',
                    backgroundColor: 'transparent',
                  }}
                />
              </Grid>
            </Grid>
            {!!hasGuardian && <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
              <Grid item xs={12} sx={{textAlign: 'center'}}>
                <Typography variant="subtitle1" sx={{
                  display: 'inline-block',
                }}>{t("nw.emission.choice_me_new_itsme.title_personal_guardian")}</Typography>
              </Grid>
              {!!samesiesAddress && <Grid item xs={12}>
                <TransparentButton
                  label={t("nw.emission.choice_minor.address_details_diff")}
                  id='address_details_diff'
                  onClick={() => {
                    setSamesiesAddress(false);
                  }}
                  sx={{
                    marginTop: 3
                  }}
                />
              </Grid>}
              {!samesiesAddress && <>
                <Grid item xs={8}>
                  <TextInput
                    value={guardian?.street || ''}
                    onChange={(v) => {
                      setGuardian({
                        ...(guardian || {
                          auth_token: '',
                          email: ''
                        }),
                        street: v
                      });
                    }}
                    starred
                    caption={t("nw.user_info.street")}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextInput
                    value={guardian?.number || ''}
                    onChange={(v) => {
                      setGuardian({
                        ...(guardian || {
                          auth_token: '',
                          email: ''
                        }),
                        number: v
                      });
                    }}
                    starred
                    caption={t("nw.user_info.number")}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextInput
                    value={guardian?.zip || ''}
                    onChange={(v) => {
                      setGuardian({
                        ...(guardian || {
                          auth_token: '',
                          email: ''
                        }),
                        zip: v
                      });
                    }}
                    starred
                    caption={t("nw.user_info.zip")}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />
                </Grid>
                <Grid item xs={8}>
                  <TextInput
                    value={guardian?.city || ''}
                    onChange={(v) => {
                      setGuardian({
                        ...(guardian || {
                          auth_token: '',
                          email: ''
                        }),
                        city: v
                      });
                    }}
                    starred
                    caption={t("nw.user_info.city")}
                    sx={{
                      borderRadius: "8px",
                      width: '100%',
                      border: "2px solid transparent",
                      borderColor: theme.palette.primary.dark,
                      paddingTop: 0.25,
                      paddingBottom: 0.25,
                      height: '40px',
                      backgroundColor: 'transparent',
                    }}
                  />
                </Grid>
              </>}
            </Grid>}
            {subBtns(3, 5, (
              !user?.street || !user?.number || !user?.zip || !user?.city || (
                !!hasGuardian && (!guardian?.street || !guardian?.number || !guardian?.zip || !guardian?.city)
              )
            ))}
          </>}
          {subStep === 5 && <>
            <Grid item xs={12} sx={{textAlign: 'center'}}>
              <Typography variant="h3" sx={{
                marginTop: 4,
                display: 'inline-block'
              }}>{t("nw.emission.choice_me_new_itsme.title_banking")}</Typography>
            </Grid>
            <Grid item xs={12}>
              <ZichtAccount
                value={user?.zicht_account || ''}
                onChange={(v) => {
                  setUser({
                    ...(user || {
                      auth_token: '',
                      email: ''
                    }),
                    zicht_account: v.target.value
                  });
                }}
                setExternalIsOkay={setIsOkay}
                starred
                caption={t("nw.user_info.zicht_account")}
                sx={{
                  borderRadius: "8px",
                  width: '100%',
                  border: "2px solid transparent",
                  borderColor: theme.palette.primary.dark,
                  paddingTop: 0.25,
                  paddingBottom: 0.25,
                  height: '40px',
                  backgroundColor: 'transparent',
                }}
              />
            </Grid>
            {subBtns(4, 6, (!user?.zicht_account || !isOkay))}
          </>}
          {subStep === 6 && <>
            <Grid item xs={12} sx={{textAlign: 'center'}}>
              <Typography variant="h3" sx={{
                marginTop: 4,
                display: 'inline-block'
              }}>{t("nw.emission.choice_me_new_itsme.title_identity")}</Typography>
            </Grid>
            <Grid item xs={12} md={!!hasGuardian ? 6 : 12} container spacing={2} sx={{alignContent: 'baseline'}}>
              <Grid item xs={12} sx={{textAlign: 'center'}}>
                <Typography variant="subtitle1" html fuck_p_tags sx={{
                  display: 'inline-block',
                }}>{t(!hasGuardian ? "nw.exit.fields.identity_front" : "nw.emission.choice_minor.title_identity_ven")}</Typography>
              </Grid>
              <Grid item xs={12} sx={{
                display: {
                  xs: 'none', md: 'flex'
                },
                "& .cust_dropzonearea > div > div": {
                  flexBasis: 'auto !important',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }}>
                <DropzoneArea
                  acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                  filesLimit={1}
                  fileObjects={[]}
                  dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                  getDropRejectMessage={(rejectedFile, x, y) => {
                    return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                  }}
                  onChange={(files) => {
                    // this.setState({user: {...this.state.user, identity: files[0]}});
                    setUser({
                      ...(user || {
                        auth_token: '',
                        email: ''
                      }),
                      identity: files[0]
                    });
                  }}
                  maxFileSize={3000000}
                  previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                  dropzoneClass="cust_dropzonearea"
                />
              </Grid>
              <Grid item xs={12} sx={{
                display: {
                  xs: 'flex', md: 'none'
                },
                "& .cust_dropzonearea > div > div": {
                  flexBasis: 'auto !important',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }}>
                <DropzoneArea
                  acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                  filesLimit={1}
                  fileObjects={[]}
                  dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                  getDropRejectMessage={(rejectedFile, x, y) => {
                    return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                  }}
                  onChange={(files) => {
                    // this.setState({user: {...this.state.user, identity: files[0]}});
                    setUser({
                      ...(user || {
                        auth_token: '',
                        email: ''
                      }),
                      identity: files[0]
                    });
                  }}
                  maxFileSize={3000000}
                  previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                  dropzoneClass="cust_dropzonearea"
                />
              </Grid>
            </Grid>
            {!!hasGuardian && <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
              <Grid item xs={12} sx={{textAlign: 'center'}}>
                <Typography variant="subtitle1" html fuck_p_tags sx={{
                  display: 'inline-block',
                }}>{t("nw.emission.choice_minor.title_identity_guardian")}</Typography>
              </Grid>
              <Grid item xs={12} sx={{
                display: {
                  xs: 'none', md: 'flex'
                },
                "& .cust_dropzonearea > div > div": {
                  flexBasis: 'auto !important',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }}>
                <DropzoneArea
                  acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                  filesLimit={1}
                  fileObjects={[]}
                  dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                  getDropRejectMessage={(rejectedFile, x, y) => {
                    return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                  }}
                  onChange={(files) => {
                    // this.setState({user: {...this.state.user, identity: files[0]}});
                    setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      identity: files[0]
                    });
                  }}
                  maxFileSize={3000000}
                  previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                  dropzoneClass="cust_dropzonearea"
                />
              </Grid>
              <Grid item xs={12} sx={{
                display: {
                  xs: 'flex', md: 'none'
                },
                "& .cust_dropzonearea > div > div": {
                  flexBasis: 'auto !important',
                  marginLeft: 'auto',
                  marginRight: 'auto'
                }
              }}>
                <DropzoneArea
                  acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                  filesLimit={1}
                  fileObjects={[]}
                  dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                  getDropRejectMessage={(rejectedFile, x, y) => {
                    return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                  }}
                  onChange={(files) => {
                    // this.setState({user: {...this.state.user, identity: files[0]}});
                    setGuardian({
                      ...(guardian || {
                        auth_token: '',
                        email: ''
                      }),
                      identity: files[0]
                    });
                  }}
                  maxFileSize={3000000}
                  previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                  dropzoneClass="cust_dropzonearea"
                />
              </Grid>
            </Grid>}
            {subBtns(5, 7, (!user?.identity || (!!hasGuardian && !guardian.identity)))}
          </>}
          {subStep === 7 && <>
            <Grid item xs={12} sx={{textAlign: 'center'}}>
              <Typography variant="h3" sx={{
                marginTop: 4,
                display: 'inline-block'
              }}>{t("nw.gifts.title_borderel")}</Typography>
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'left'}}>
              <Typography variant="body1" html fuck_p_tags sx={{
                display: 'inline-block',
              }}>{t("nw.gifts.body_borderel_pre_button")}</Typography>
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'left'}}>
              <DarkGreenButton
                label={t(!theKey.borderel_blank ? "nw.gifts.cta_generate" : "nw.gifts.cta_download")}
                id="borderel_btn"
                loading={mutationCustomAction.isPending}
                startIcon={!theKey.borderel_blank ? <DesignServicesIcon /> : <DownloadIcon />}
                sx={{
                  marginBottom: 1,
                  borderColor: theme.palette.primary.dark,
                  "&:hover": {
                    borderColor: theme.palette.primary.dark,
                    backgroundColor: theme.palette.primary.light,
                    color: theme.palette.primary.dark,
                  },
                  "&.Mui-disabled": {
                    color: 'grey',
                  },
                }}
                onClick={() => {
                  if (!theKey.borderel_blank) {
                    const formData = new FormData();
                    formData.append('object', 'emission_key');
                    formData.append('class_action', 'custom_api_generate_borderel');
                    formData.append('id', theKey.id?.toString() || '');
                    formData.append('user[first_name]', user.first_name || '');
                    formData.append('user[last_name]', user.last_name || '');
                    formData.append('user[birth_date]', user.birth_date || '');
                    formData.append('user[gender]', user.gender || '');
                    formData.append('user[email]', user.email || '');
                    formData.append('user[phone]', user.phone || '');
                    formData.append('user[street]', user.street || '');
                    formData.append('user[number]', user.number || '');
                    formData.append('user[zip]', user.zip || '');
                    formData.append('user[city]', user.city || '');
                    formData.append('user[zicht_account]', user.zicht_account || '');
                    formData.append('user[identity]', user.identity || '');
                    if (!!guardian?.first_name) {
                      formData.append('guardian[first_name]', guardian.first_name || '');
                      formData.append('guardian[last_name]', guardian.last_name || '');
                      formData.append('guardian[birth_date]', guardian.birth_date || '');
                      formData.append('guardian[email]', guardian.email || '');
                      formData.append('guardian[phone]', guardian.phone || '');
                      formData.append('guardian[street]', guardian.street || '');
                      formData.append('guardian[number]', guardian.number || '');
                      formData.append('guardian[zip]', guardian.zip || '');
                      formData.append('guardian[city]', guardian.city || '');
                      formData.append('guardian[identity]', guardian.identity || '');
                    }

                    mutationCustomAction.mutate({
                      formData: formData,
                      step: 20
                    });
                  }
                  if (!!theKey.borderel_blank) {
                    window.open(theKey.borderel_blank, "_BLANK");
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{textAlign: 'left'}}>
              <Typography variant="body1" html fuck_p_tags sx={{
                display: 'inline-block',
              }}>{t("nw.gifts.body_borderel_post_button")}</Typography>
            </Grid>
            
            <Grid item xs={12} sx={{
              display: {
                xs: 'none', md: 'flex'
              },
              "& .cust_dropzonearea > div > div": {
                flexBasis: 'auto !important',
                marginLeft: 'auto',
                marginRight: 'auto'
              }
            }}>
              <DropzoneArea
                acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                filesLimit={1}
                fileObjects={[]}
                dropzoneText={he.decode(t('nw.general.dropzone_text').replace(/<[^>]*>?/gm, ''))}
                getDropRejectMessage={(rejectedFile, x, y) => {
                  return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                }}
                onChange={(files) => {
                  // this.setState({user: {...this.state.user, identity: files[0]}});
                  setBorderel(files[0]);
                }}
                maxFileSize={3000000}
                previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                dropzoneClass="cust_dropzonearea"
              />
            </Grid>
            <Grid item xs={12} sx={{
              display: {
                xs: 'flex', md: 'none'
              },
              "& .cust_dropzonearea > div > div": {
                flexBasis: 'auto !important',
                marginLeft: 'auto',
                marginRight: 'auto'
              }
            }}>
              <DropzoneArea
                acceptedFiles={['image/gif', 'image/jpeg', 'image/png', '.pdf']}
                filesLimit={1}
                fileObjects={[]}
                dropzoneText={he.decode(t('nw.general.dropzone_text_mobile').replace(/<[^>]*>?/gm, ''))}
                getDropRejectMessage={(rejectedFile, x, y) => {
                  return he.decode(t("nw.general_error.dropzone.rejected", {name: rejectedFile.name}).replace(/<[^>]*>?/gm, ''));
                }}
                onChange={(files) => {
                  // this.setState({user: {...this.state.user, identity: files[0]}});
                  setBorderel(files[0]);
                }}
                maxFileSize={3000000}
                previewGridProps={{item: {style: {maxWidth: '100%', flexBasis: '100%'}}}}
                dropzoneClass="cust_dropzonearea"
              />
            </Grid>
            {subBtns(6, 8, (!borderel || !theKey.borderel_blank))}
          </>}




          {subStep === 8 && <>
            <Grid item xs={12} sx={{textAlign: 'center'}}>
              <Typography variant="h3" sx={{
                marginTop: 4,
                display: 'inline-block'
              }}>{t("nw.gifts.title_overview")}</Typography>
            </Grid>
            <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="h5" sx={{
                  marginTop: 2,
                  display: 'inline-block'
                }}>{t(!!hasGuardian ? "nw.emission.choice_me_new_itsme.title_personal_ven" : "nw.emission.choice_me_new_itsme.title_personal")}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.first_name")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.first_name}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.last_name")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.last_name}</Typography>
              </Grid>
              <Grid item xs={6} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.birth_date")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.birth_date}</Typography>
              </Grid>
              <Grid item xs={6} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.gender")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.gender}</Typography>
              </Grid>
              <Grid item xs={8} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.zicht_account")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.zicht_account}</Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="h5" sx={{
                  marginTop: 2,
                  display: 'inline-block'
                }}>{t(!!hasGuardian ? "nw.emission.choice_me_new_itsme.title_personal_ven_contact" : "nw.emission.choice_me_new_itsme.title_contact_extra")}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.email")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.email}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.phone")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.phone}</Typography>
              </Grid>
              <Grid item xs={8} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.street")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.street}</Typography>
              </Grid>
              <Grid item xs={4} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.number")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.number}</Typography>
              </Grid>
              <Grid item xs={4} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.zip")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.zip}</Typography>
              </Grid>
              <Grid item xs={8} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.city")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{user?.city}</Typography>
              </Grid>
            </Grid>
            {!!hasGuardian && <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="h5" sx={{
                  marginTop: 2,
                  display: 'inline-block'
                }}>{t("nw.emission.choice_me_new_itsme.title_personal_guardian")}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.first_name")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{guardian?.first_name}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.last_name")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{guardian?.last_name}</Typography>
              </Grid>
              <Grid item xs={6} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.birth_date")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{guardian?.birth_date}</Typography>
              </Grid>
            </Grid>}
            {!!hasGuardian && <Grid item xs={12} md={6} container spacing={2} sx={{alignContent: 'baseline'}}>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="h5" sx={{
                  marginTop: 2,
                  display: 'inline-block'
                }}>{t("nw.emission.choice_me_new_itsme.title_personal_guardian_contact")}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.email")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{guardian?.email}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.phone")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{guardian?.phone}</Typography>
              </Grid>
              <Grid item xs={8} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.street")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{guardian?.street}</Typography>
              </Grid>
              <Grid item xs={4} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.number")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{guardian?.number}</Typography>
              </Grid>
              <Grid item xs={4} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.zip")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{guardian?.zip}</Typography>
              </Grid>
              <Grid item xs={8} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}>{t("nw.user_info.city")}</Typography><br/>
                <Typography variant="body1" sx={{
                  marginTop: 0,
                  paddingLeft: 2,
                  display: 'inline-block'
                }}>{guardian?.city}</Typography>
              </Grid>
            </Grid>}
            <Grid item xs={12} container spacing={2} sx={{alignContent: 'baseline'}}>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="h5" sx={{
                  marginTop: 2,
                  display: 'inline-block'
                }}>{t(!hasGuardian ? "nw.gifts.title_identity_short" : "nw.emission.choice_minor.title_identity_ven_short")}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}><CheckCircleIcon sx={{color: theme.palette.primary.light, marginBottom: '-8px'}} />&nbsp;{user?.identity?.name}</Typography>
              </Grid>
              {!!hasGuardian && <>
                <Grid item xs={12} sx={{textAlign: 'left'}}>
                  <Typography variant="h5" sx={{
                    marginTop: 2,
                    display: 'inline-block'
                  }}>{t("nw.emission.choice_minor.title_identity_guardian_short")}</Typography>
                </Grid>
                <Grid item xs={12} sx={{textAlign: 'left'}}>
                  <Typography variant="subtitle1" sx={{
                    marginTop: 1,
                    display: 'inline-block'
                  }}><CheckCircleIcon sx={{color: theme.palette.primary.light, marginBottom: '-8px'}} />&nbsp;{guardian?.identity?.name}</Typography>
                </Grid>
              </>}
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="h5" sx={{
                  marginTop: 2,
                  display: 'inline-block'
                }}>{t("nw.gifts.title_borderel")}</Typography>
              </Grid>
              <Grid item xs={12} sx={{textAlign: 'left'}}>
                <Typography variant="subtitle1" sx={{
                  marginTop: 1,
                  display: 'inline-block'
                }}><CheckCircleIcon sx={{color: theme.palette.primary.light, marginBottom: '-8px'}} />&nbsp;{borderel?.name}</Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} sx={{
              marginBottom: 2.5,
              marginTop: 4
            }}>
              <Box
                sx={{
                  width: {
                    xs: '100%',
                    md: '100%',
                    lg: '670px'
                  },
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  backgroundColor: 'white'
                }}
              >
                <Grid container spacing={0}>
                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.gifter_name"), 
                    theKey.gifter?.first_name, 
                    undefined,
                    true
                  )}

                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.receiver_name"), 
                    theKey.gift_data?.first_name, 
                    undefined,
                    true
                  )}

                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.gift_expiry_date"), 
                    DateTime.fromISO(theKey.gift_expiry_date).toFormat("dd/LL/y"), 
                    undefined, 
                    true
                  )}

                  {tableRow(
                    t("nw.emission.steps.stock.order_detail.amount"), 
                    undefined, 
                    <ShareShower sx={{fontWeight: {xs: 'bold', md: 'normal'}}} amount={theKey.proposed_amount} share={'B'} />, 
                    true
                  )}
                </Grid>
              </Box>
            </Grid>
            {subBtns(7, 8, false, () => {
              const formData = new FormData();
              formData.append('object', 'emission_key');
              formData.append('class_action', 'custom_api_redeem');
              formData.append('id', theKey.id?.toString() || '');
              formData.append('borderel', borderel || '');

              mutationCustomAction.mutate({
                formData: formData,
                step: 50
              });
            }, true)}
          </>}
        </>}
      </Grid>
    </WhiteSection>
  </>;
}